import { IComboBoxStyles } from "@fluentui/react";

export const textFieldStyles = {
  fieldGroup: { width: "200px" },
};

export const textFieldGrayStyles = {
  fieldGroup: {
    width: "200px",
    backgroundColor: "rgb(243, 242, 241)",
  }
}

export const comboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 200,
  },
};

export const disbaledComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 200,
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
    "& .ms-ComboBox-container": {
      "& .ms-ComboBox": {
        background: "yellow",
        borderWidth: 1,
        borderColor: "rgb(50, 49, 48)",
      },
    },
    div: {
      background: "green",
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
    },
    "& .ms-ComboBox": {
      background: "red",
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
      "& input": {
        color: "rgb(50, 49, 48)",
      },
      "& button": {
        "& span": {
          "& i": {
            color: "rgb(50, 49, 48)",
          },
        },
      },
    },
  },
  container: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
  },
  label: {
    color: "rgb(50, 49, 48)",
  },
  input: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
  },
};

export const centerAlignedCheckboxStyles = {
  label: {
    alignItems: "center",
  },
};
export const endAlignedCheckboxStyles = {
  label: {
    alignItems: "flex-end",
  },
};
